module.exports = __webpack_public_path__ + "static/media/chenle-1.jpeg";